export default __webpack_public_path__ + "static/media/Suyane_Mike_HickDuarte_34074.2bcc4173.jpg";